import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime, finalize} from 'rxjs/operators';
import {countryConfig} from 'src/country-config/country-config';
import {FormErrorValidatorService} from '../../services/form-error-validator.service';
import {emailFormatValidator} from '../../custom-validators/email-format-validator';
import {emailNumberValidator} from '../../custom-validators/email-number-validator';
import {LoginFormVm} from '../../../../view-model/login-form/login-form.vm';
import {ToastEvent} from '../../event-listeners/toast/toast.event';
import { SessionEvent } from '../../event-listeners/session/session.event';
import { UpdateSessionModalEvent } from '../../event-listeners/update-session-modal/update-session-modal.event';
import { UpdateNotificationModalEvent } from '../../event-listeners/update-notification-modal/update-notification-modal.event';
import { PrimeEvent } from '../../event-listeners/prime/prime.event';
import { Router } from '@angular/router';
import { SupportVm } from 'src/app/view-model/support/support.vm';
import { Location } from '@angular/common';
import { recaptchaEnv } from 'src/environments/colombia/recaptcha.env';
import { Subscription } from 'rxjs';
import { FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';

declare const FB: any;

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  providers: [FormBuilder],
})
export class LoginFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() idPrefix = '';
  @Input() isModal = false;
  @Input() isBanner = false;
  @Input() openModal = false;
  @Input() emailErrorRegister = null;
  @Output() openSignUp = new EventEmitter<any>();
  @Output() loggedIn = new EventEmitter<any>();
  @Output() resetPassword = new EventEmitter<any>();
  @Output() selectMethod = new EventEmitter<any>();
  @Output() openResetPasswordModal = new EventEmitter<any>();
  @Output() openSelectMethodMessageModal = new EventEmitter<any>();
  @Output() resetPasswordMode = new EventEmitter<any>();
  @Output() selectMethodMessageMode = new EventEmitter<any>();
  @Output() userNotFound = new EventEmitter<any>();
  @Output() validateCodeMode = new EventEmitter<any>();
  @Output() selectEmailMode = new EventEmitter<any>();
  @Output() openValidateCodeModal = new EventEmitter<any>();
  @Output() openSelectEmailModal = new EventEmitter<any>();
  @Output() errorEmailTitle = new EventEmitter<any>();

  countryConfig = countryConfig;
  list = [];
  swZdWidget = false;
  customerId;
  enableValidateCode = false;
  enableSelectEmail = false;
  loginForm: FormGroup;
  validEmail = false;
  isSocialNetwork = false;
  showAll = false;
  loadNavBar = false;
  registerModal;
  isLoading = {
    facebook: false,
    google: false,
    email: false,
    apple: false,
  };
  error = LoginFormComponent.errorObj();
  formConfig = {
    minPassword: 6,
    maxPassword: 200,
    maxToken: 1500,
    email: 100,
  };
  facebookLoginInProgress: boolean = false;
  phonecode = countryConfig.phoneCode;
  showCountry = false;
  showPass = false;
  validNumber = false;
  errorObj: any = null;
  enableResetPassword = false;
  enableSelectMethodMessage = false;
  inputPass = true;
  customerOptions = [];
  emailValidators = [
    Validators.required,
    Validators.maxLength(this.formConfig.email),
    emailFormatValidator,
  ];
  emailNumberValidators = [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(countryConfig.phoneLength),
    emailNumberValidator,
  ];

  loginNumberModal = false;
  loginNumberSelectEmail = false;
  loginNumberEnterCode = false;
  titleNumberSelectEmail = true;
  errorEmail: any;
  toggleLoading = false;
  inputFocus: string;
  recaptchaToken: string | undefined;
  key: string = recaptchaEnv.recaptchaSiteKey;
  action = 'login';
  flagRecaptcha: boolean = false;
  configRecaptchaSubscription: Subscription;
  eventRecaptchaSubscription: Subscription;
  recaptchaConfigLoaded: boolean = false
  
  public counter: number = 1;
  subscriptionList: Subscription[] = [];
  authActiveConfig: FirebaseFlags['authActiveConfig'];
  socialNetworksNames = {
    FACEBOOK: 'Facebook',
    GOOGLE: 'Google',
    APPLE: 'Apple',
  };
  selfCheckout = false;

  set errorMessage(message) {
    this.errorObj = message;

  }

  get errorMessage() {
    return this.errorObj;
  }

  get placeholderEmail() {
    return countryConfig.loginForm.placeholderEmail
  }

  get placeholder() {
    return countryConfig.loginForm.placeholderEmail
  }

  static errorObj() {
    return {email: '', password: ''};
  }

  onSuccess(event) {
    this.loggedIn.emit(event);
  }

  setLoading(provider) {
    this.isLoading = {
      facebook: false,
      google: false,
      email: false,
      apple: false,
    };

    switch (provider) {
      case 'GOOGLE':
        this.isLoading.google = true;
        return;
      case 'FACEBOOK':
        this.isLoading.facebook = true;
        return;
      case 'EMAIL':
        this.isLoading.email = true;
        return;
      default:
        this.isLoading.email = false;
    }
  }

  constructor(private formBuilder: FormBuilder,
    private fev: FormErrorValidatorService,
    private vm: LoginFormVm,
    private toastEvent: ToastEvent,
    private loginEvent: SessionEvent,
    private sessionModalStatusEvent: UpdateSessionModalEvent,
    private notificationModalEvent: UpdateNotificationModalEvent,
    private primeEvent: PrimeEvent,
    private router: Router,
    private supportVm: SupportVm,
    private location: Location
    ) { }

  init() {
    this.enableValidateCode = false;
    this.enableSelectEmail = false;
    this.isSocialNetwork = false;
    this.setLoading(null);
    this.enableResetPassword = false;
    this.enableSelectMethodMessage = false;
    this.errorMessage = null;
    this.errorEmail = null;
    this.error = LoginFormComponent.errorObj();
    this.loginForm = this.formBuilder.group({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(this.formConfig.minPassword),
      ]),
      email: new FormControl(''),
      socialEmail: new FormControl(''),
      token: new FormControl(''),
      countryCode: new FormControl(countryConfig.prefixPhone, [Validators.required, Validators.maxLength(2)]),
      registeredBy: new FormControl('EMAIL'),
    });
    if (countryConfig.loginForm.FormControlValidate) {
      this.loginForm.addControl('pcode', new FormControl(this.phonecode[0]));
    }
    if(this.emailErrorRegister){
      this.errorEmail = this.emailErrorRegister;
      this.showCountry = true;
      this.errorEmailTitle.emit({showTitle: false});
      this.loginForm.get('email').setValidators(null);
    }
    this.loginForm.valueChanges.pipe(debounceTime(300)).subscribe(values => {

      this.errorMessage = '';
      const maxPassword = this.isSocialNetwork ? this.formConfig.maxToken : this.formConfig.maxPassword;
      if (values.password.length > 0) {
        this.fev.passwordValidator('password', values, this.loginForm.get('password'), this.error, {...this.formConfig, maxPassword});
      }
      if (values.email.length <= 0) {
        this.showCountry = false;
        this.showPass = false;
        this.loginForm.patchValue({password: ''});
      }
      const valid = parseInt(values.email, 10);
      this.isLoading.email = false;
      this.validNumber = false;
      if (!countryConfig.loginForm.valuesValidate && !Number.isNaN(valid) && valid.toString() == values.email ) {
        this.showCountry = true;
        this.showPass = false;
        this.errorMessage = null;
        this.isLoading.email = true;
        this.loginForm.get('email').setValidators(this.emailNumberValidators);
        if (this.loginForm.get('email').errors === null && values.email.length === countryConfig.phoneLength) {
          let num;
          if (countryConfig.loginForm.countryCodeValidate) {
            num = parseInt(`${values.countryCode}${values.email}`, 10);
          } else {
            num = parseInt(`${values.countryCode}${values.pcode}${values.email}`, 10);
          }
          this.list = [];
          let emailCallcenter = this.errorEmail?.origin === 'CallCenter' ? this.errorEmail.email : undefined;
          this.vm.getCustomerLogin(num, emailCallcenter).pipe(finalize(() => {
            this.isLoading.email = false;
          })).subscribe(res => {

            if (res?.length > 0) {
              const typeOriginUser = res[0]?.requiredModifyData;
              if (typeOriginUser) {
                this.vm.setItemSessionStorage('potencialCustomerExpress', true);
              }
            }

            setTimeout(() => {

              this.loginNumberModal = false;
              this.loginNumberSelectEmail = false;
              this.loginNumberEnterCode = false;

              if (res.code === 'NO_CONTENT') {
                this.isLoading.email = false;
                this.errorMessage = res.message;
              } else {
                this.transformListDataOrigin(res);
              }

            }, 300);
          }, error => {
            this.isLoading.email = false;
            this.errorMessage = error.message;
          });
        }
      } else {
        this.showCountry = false;
        this.validNumber = false;
        const value = {email: values.email.toLowerCase()};
       this.loginForm.get('email').setValidators(this.emailValidators);
        this.fev.emailValidator('email', values, this.loginForm, this.error);
        const str = values.email.includes("@")
          if (values.email.length > 5 && this.loginForm.get('email').errors === null && this.inputFocus !== 'password') {
            this.vm.getCustomerOrigin(value).subscribe(customerOrigins => {
              const hasOrigins = customerOrigins?.length;
              const firtsOriginCustomer = customerOrigins[0]?.origin;

              if (hasOrigins >= 1 && firtsOriginCustomer) {
                customerOrigins.origin = firtsOriginCustomer;
              }

              if (values.registeredBy === 'FACEBOOK' && customerOrigins.origin === 'Facebook') {
                this.setLoading(null);
                this.loginForm.get('email').setValidators(Validators.maxLength(this.formConfig.email));
                this.error.email = '';
                if (values.token) {
                  this.logIn();
                  return;
                }
              }

              if (customerOrigins[0]?.requiredModifyData) {
                this.vm.setItemSessionStorage('potencialCustomerExpress', true);
                this.transformListDataOrigin(customerOrigins);
                this.numberLogIn();
                return
              }

              if ((customerOrigins.origin === 'Email' || customerOrigins.origin === 'CallCenter' || customerOrigins.origin === 'Express')) {
                this.showPass = true;
                this.errorMessage = '';
                this.getConfigurationRecaptcha();

                if (hasOrigins && customerOrigins[0]?.customerId && customerOrigins[0]?.contactList) {
                  this.transformListDataOrigin(customerOrigins);
                }

              } else {
                this.showPass = false;
              }

              const isNoContent = customerOrigins?.code === 'NO_CONTENT';
              const isStrTrue = str === true;
              const isEmailValid = this.loginForm.get('email').errors === null;

              if (customerOrigins.origin && values.registeredBy.toLowerCase() !== customerOrigins.origin.toLowerCase()) {
                const {email, countryCode, registeredBy } = values;
                this.errorEmail = {...customerOrigins, email, countryCode, registeredBy};
                if(this.isBanner) {
                  this.sessionModalStatusEvent.changeModalStatus({open: true});
                  this.sessionModalStatusEvent.changeErrorEmail(this.errorEmail);
                  this.toggleLoading = false;
                  return;
                }
                this.errorMessage = '';
                this.showCountry = true;
                this.errorEmailTitle.emit({showTitle: false});
                this.loginForm.get('email').setValidators(null);
              } else if (isNoContent && isStrTrue && isEmailValid) {
                  this.toggleLoading = false;
                  this.errorMessage = customerOrigins.message;
              }
            }, error => {
              this.toggleLoading = false;
              this.showPass = false;
              if (this.loginForm.valid) {
                this.errorMessage = error?.message || '';
              }
            });
          }

      }
    });
  }

  facebook() {
    this.fetchSocialNetworkData('FACEBOOK');
  }

  google() {
    this.fetchSocialNetworkData('GOOGLE');
  }

  apple() {
    this.fetchSocialNetworkData('APPLE');
  }

  email(){
    this.loginForm.patchValue({registeredBy: 'EMAIL', password: ''});
    this.errorEmail = null;
    this.errorEmailTitle.emit({showTitle: true});
    this.showCountry = false;
  }

  onSelectedCountry(event) {
    this.loginForm.patchValue({countryCode: event.prefix});
  }

  openSessionModal() {
    this.loginEvent.setLoginModalStatus({
      open: true
    });
    setTimeout(()=> {
        document.getElementById("login-open-sign-up").click();
    }, 250);
  }

  fillFormFromSocialNetworkData(data) {
    const {credential} = data;
    const isGoogle = credential.providerId === 'google.com';
    const profile = data.additionalUserInfo ? data.additionalUserInfo.profile : {};
    const registrationData = {
      email: isGoogle ? data.user ? data.user.email : profile.email : '',
      password: credential.accessToken,
      token: isGoogle ? credential.idToken : credential.accessToken || credential.access_token,
    };

    this.loginForm.patchValue(registrationData);
  }

  fetchSocialNetworkData(provider) {
    this.isSocialNetwork = true;
    this.setLoading(provider);
    this.loginForm.patchValue({registeredBy: provider});
    this.vm.fetchFirebaseData(this.loginForm.value)
      .pipe(finalize(() => {
        this.setLoading(null);
      }))
      .subscribe(response => {
        if (response && (response.idCustomerWebSafe || response.documentNumber)) {
          this.loggedIn.emit(response);
          return;
        }
        this.setLoading(null);
        this.fillFormFromSocialNetworkData(response);
        this.logIn();
      }, error => {
        this.loginForm.controls['email'].setValue(error.email);
        this.errorMessage = null;
        document.querySelector('#login-general-error-message').textContent = error.message;
        this.errorMessage = 'El usuario canceló el login o no lo autorizó completamente.';
        this.toastEvent.updateToast({error: true, message: error.message})
      });
  }

  numberLogIn() {

    if (!countryConfig.loginForm.sendMessage || this.list.length > 1) {
      if (this.isModal) {
        this.enableSelectEmail = true;
        this.errorEmail = null;
        this.selectEmailMode.emit(true);
        return;
      }
      this.openSelectEmailModal.emit(true);      
    } else {
      this.enableValidateCode = true;
      this.validateCodeMode.emit(true);
      this.vm.sendMessage('phone', this.customerId).subscribe();
    }

  }

  onValidateCodeMode(event) {
    this.validateCodeMode.emit(event);
  }

  onSelectEmailMode(event) {
    this.selectEmailMode.emit(event);
  }


  getSubscriptionPlan(){
    this.primeEvent.changePrimePlan( { update: true } );
  }

  clearPrimeUser( item ){
    this.vm.removeItemSessionStorage( item );
  }

  openSignUpForm() {
    this.openSignUp.emit(true);
  }

  openResetPassword() {
    if (this.isModal) {
      this.enableResetPassword = true;
      this.resetPasswordMode.emit(true);
      return;
    }
    this.openResetPasswordModal.emit(true);
  }

  openSelectMethodMessage() {
    this.vm.getCustomerLogin(this.loginForm.controls.email.value).subscribe(res => {

      if (res?.length > 0) {
        res.customers = res.map(customer => ({
          idCustomer: customer.customerId,
          list: customer.contactList,
        }))
      }
      
      this.customerOptions = res.customers;
      if (this.isModal) {
        this.enableSelectMethodMessage = true;
        this.selectMethodMessageMode.emit(true);
        this.vm.activeModalCretePassword();
        return;
      }
      this.openSelectMethodMessageModal.emit(true);
    }, error => {
      this.errorMessage = error.message;
    });
  }

  onResetPassword(event) {
    this.resetPassword.emit(event);
  }

  onSelectMethod(event) {
    this.selectMethod.emit(event);
  }

  facebookLoginListener() {
    if (this.isLoading.email || this.isLoading.facebook || this.isLoading.google || this.isLoading.apple|| this.facebookLoginInProgress) {
      return;
    }
    
    this.errorMessage = null;
    this.isSocialNetwork = true;
    this.setLoading('FACEBOOK');
    this.toggleLoading = true;
    this.loginForm.patchValue({registeredBy: 'FACEBOOK'});

    this.facebookLoginInProgress = true;

    FB.login(response => {
      this.facebookLoginInProgress = false; 
      if (response.status === 'connected') {
        let data = {
          ...response,
          token: response.authResponse.accessToken,
        };
        FB.api('/me', {fields: 'name,email'}, res => {
          data = {
            ...data,
            ...res,
          };
          const registrationData = {
            email: data.email,
            socialEmail: data.email,
            password: data.token,
            token: data.token,
          };
          this.loginForm.patchValue(registrationData);
          this.logIn();
        }, error => {
          this.setLoading(null);
          data = {
            ...data,
            ...error,
          };

          if (data.email && data.token) {
            const registrationData = {
              email: data.email,
              socialEmail: data.email,
              password: data.token,
              token: data.token,
            };
            this.loginForm.patchValue(registrationData);
            return;
          }
          this.errorMessage = 'Error al iniciar sesión con Facebook';
          this.toggleLoading = false;
        });
      } else {
        this.setLoading(null);
        this.toggleLoading = false;
        this.errorMessage = 'El usuario canceló el login o no lo autorizó completamente.';
      }
    }, {
      scope: 'email,public_profile',
      return_scopes: true,
    });
  }

  openChat() { this.supportVm.openChat(); }

  listenUpdatedErrorEmail(): void {
    this.sessionModalStatusEvent.updatedErrorEmail.subscribe(errorEmail => {
      if(errorEmail) {
        this.errorEmail = errorEmail;
        this.loginForm.patchValue({email: errorEmail.email, registeredBy: errorEmail.registeredBy});
      }
    });
  }

  ngOnInit() {
    this.resetPasswordMode.emit(false);
    this.selectMethodMessageMode.emit(false);
    this.init();
    if(!this.isBanner) this.listenUpdatedErrorEmail();

    if(this.isBanner){
      this.loginForm.controls['email'].setValidators( [Validators.minLength(10)] );
    }
    this.getRemoteConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isModal) {
      if (changes && changes.openModal && changes.openModal.currentValue && changes.openModal.currentValue.open) {
        this.init();
      }
    }
  }

  numberLogInBanner() {
    if(!this.validNumber) return;
    if ( this.loginNumberModal ) {
      this.loginNumberModal = false;
      setTimeout( () => {
        this.loginNumberModal = true;
      }, 100)
    } else if( this.loginForm.get('email').value )  {
      this.loginNumberModal = true;

      if(this.list.length >1){
            this.loginNumberSelectEmail = true;
          }else{            
            this.vm.sendMessage('phone', this.customerId).subscribe(() => {
              this.loginNumberEnterCode = true;
            });
      }
    } else {
      this.loginNumberSelectEmail = this.list.length > 1;
      this.loginNumberEnterCode = this.list.length === 1;
    }
  }

  cleanSpaces(event) {
    const formControlName = event.target.attributes['formcontrolname'].value;
    this.loginForm.controls[formControlName].setValue(this.loginForm.value[formControlName].replace(/ /g, ''));
  
  }

  resetSpace(event) {
    this.inputFocus = event.target.attributes['formcontrolname'].value;
    if(event.charCode === 32){
      return false;
    }
  }
  transformListDataOrigin(data) {
    if (data?.length > 0) {
      data.customers = data.map(customer => ({
        idCustomer: customer.customerId,
        list: customer.contactList,
      }))
    }
    this.list = data.customers;
    this.customerId = data.customers[0].idCustomer;
    this.validNumber = !!(data && data.customers);
    this.selfCheckout = data[0]?.selfCheckout;
  }

  validateLogin(responseRecaptcha?: object) {
    if (this.isLoading.email || !this.loginForm.valid) {
      return;
    }

    this.setLoading('EMAIL');
    this.errorMessage = null;

    this.vm.login(this.loginForm.value, responseRecaptcha)
      .pipe(finalize(() => {
        this.setLoading(null);
      }))
      .subscribe(response => {

        if (response) { this.toggleLoading = false; }

        if (this.counter === 1) {
          this.sessionModalStatusEvent.updatedOrigin.subscribe(origin => {
            if (origin.notification) {
              this.notificationModalEvent.changeModalStatus({open: true});
              this.counter += 1;
            }
          });
        }
        this.clearPrimeUser('primeSubscription');
        this.getSubscriptionPlan();
        this.loggedIn.emit(response);
        this.router.navigate(['/']);
      }, error => {

        if (error?.code === 'BUSINESS_ERROR' && error?.message.includes('2FA')) {
          this.numberLogIn();
        }

        this.setLoading(null);
        this.toggleLoading = false;
        this.errorMessage = error;
        document.querySelector('#login-general-error-message').textContent = error.message;
        this.errorMessage = error;
        this.toastEvent.updateToast({error: true, message: error.message});
      });
  }

  getRecaptchaToken() {
    this.vm.actionRecaptcha(this.action).then(
      async token => {
        if (token.length > 300) {
          const hashedEmail = await this.vm.transformHashSHA256(this.loginForm.controls.email.value);

          const data = {
            event: {
              token,
              siteKey: this.key,
              userAgent: navigator.userAgent,
              expectedAction: this.action,
              hashedAccountId: hashedEmail,
              requestedUri: this.location.path(true) || 'https://www.farmatodo.com.co/',
              userIpAddress: this.vm.getCustomerIpAddress(),
              fraudPrevention: 'ENABLED',
              userInfo: {
                accountId: hashedEmail,
                userIds: [
                  {
                    email: hashedEmail,
                  },
                ],
              },
            },
          };

          this.eventRecaptchaSubscription = this.vm.getEvaluationRecaptcha(data).subscribe(
            response => {
              this.validateLogin(response);
            }, error => {
              console.error('Error al obtener la evaluación de recaptcha', error);
              this.validateLogin();
            },
          );
        } else {
          console.error('Recaptcha token is too short:', token);
          this.validateLogin();
        }
      }, error => {
        console.error('Error al obtener el token de recaptcha', error);
        this.validateLogin();
      },
    );
  }

  logIn() {
    if (this.flagRecaptcha) {
      this.getRecaptchaToken();
    } else {
      this.validateLogin();
    }
  }

  getConfigurationRecaptcha() {
    if (this.recaptchaConfigLoaded) {
      return; 
    }

    this.configRecaptchaSubscription = this.vm.getConfigurationRecaptcha().subscribe((response) => {
      if (response) {
        this.flagRecaptcha = response?.value?.enableInWebLogin;
        this.recaptchaConfigLoaded = true;
      }
    }, (error) => {
      console.error('Error al obtener la configuración de recaptcha', error);
    });
  }

  ngOnDestroy(): void {
    this.configRecaptchaSubscription?.unsubscribe();
    this.eventRecaptchaSubscription?.unsubscribe();
    this.subscriptionList?.forEach(subscription => subscription?.unsubscribe());
  }
  
  getRemoteConfig(): void {
    const subscription = this.vm.getRemoteConfig()
      .subscribe({
        next: (config) => {
          this.authActiveConfig = config?.authActiveConfig;
        },
        error: (error) => {
          console.error('Error fetching remote config', error);
        },
      });

    this.subscriptionList.push(subscription);
  }

  isSomeAuthActive(): boolean {
    const activeFacebook = this.authActiveConfig?.facebook;
    const activeGoogle = this.authActiveConfig?.google;
    const activeApple = this.authActiveConfig?.apple;

    return activeFacebook || activeGoogle || activeApple;
  }

  showGmailIfErrorEmail(): boolean {
    const userRegisteredByGmail = this.errorEmail?.origin === this.socialNetworksNames.GOOGLE;
    const isGoogleActive = this.authActiveConfig?.google;

    return userRegisteredByGmail && isGoogleActive;
  }

  showFacebookIfErrorEmail(): boolean {
    const userRegisteredByFacebook = this.errorEmail?.origin === this.socialNetworksNames.FACEBOOK;
    const isFacebookActive = this.authActiveConfig?.facebook;

    return userRegisteredByFacebook && isFacebookActive;
  }

  showAppleIfErrorEmail(): boolean {
    const userRegisteredByApple = this.errorEmail?.origin === this.socialNetworksNames.APPLE;
    const isAppleActive = this.authActiveConfig?.apple;

    return userRegisteredByApple && isAppleActive;
  }
  
}
